// Shared logo/asset URL resolver used by every component that renders a
// business logo. On production, only URLs prefixed with `/api` route through
// Kubernetes ingress to the backend pod; naked `/uploads/...` paths hit the
// React app and return the SPA HTML shell (broken images).
//
// This helper normalises whatever we've stored in `business.logo_url` so it
// works in every environment:
//   - absolute http(s) URL → as-is
//   - `/api/uploads/...`   → prepend REACT_APP_BACKEND_URL
//   - `/uploads/...`       → prepend REACT_APP_BACKEND_URL + `/api`
//   - anything else        → as-is (data: URLs, etc.)

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

export function resolveAssetUrl(url) {
  if (!url) return null;
  if (typeof url !== "string") return null;
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  if (url.startsWith("data:") || url.startsWith("blob:")) return url;
  if (url.startsWith("/api/uploads/")) return `${BACKEND_URL}${url}`;
  if (url.startsWith("/uploads/")) return `${BACKEND_URL}/api${url}`;
  return url;
}

// Back-compat alias — some pages import as `resolveLogoUrl`.
export const resolveLogoUrl = resolveAssetUrl;
